import store from '../store/index'
import { newNotificationMessage, openNotification, setNotificationSeverity } from '../actions/index'

type NotificationSeverity = 'success' | 'error' | 'warning' | 'info'

export const showNotification = (message: string, severity: NotificationSeverity = 'info') => {
  store.dispatch(setNotificationSeverity(severity))
  store.dispatch(newNotificationMessage(message))
  store.dispatch(openNotification(true))
}

export const showSuccess = (message: string) => {
  showNotification(message, 'success')
}

export const showError = (message: string) => {
  showNotification(message, 'error')
}

export const showWarning = (message: string) => {
  showNotification(message, 'warning')
}

export const showInfo = (message: string) => {
  showNotification(message, 'info')
}
